import {
  CHART_TYPES, fetchChartSvg, getAllPlanetData, getAllHouseData, getPanchang, buildAvakhada,
  getDashaTree, findRunningPath, getSarvashtakavarga, getPredictionsCached, getSaturnTransitSign,
  computeManglik, computeKalsarpa, sadesatiStatus, extractYogas, groupPredictions, remedyFor, vargaShortKey,
} from '@astro/vedastro'
import { chartLayoutData, buildChartLayout, stripPlanetLayer, buildNumberedSvg } from '../chartSvg'

/** The two charts the report carries — Lagna (D1) and Navamsha (D9). */
export const REPORT_CHARTS = ['RasiD1', 'NavamshaD9']

/** Settle a promise to its value, or null — a failed section is skipped, not fatal. */
const soft = (p) => p.then((v) => v, (err) => {
  console.warn('[kundli-studio] report section unavailable', err)
  return null
})

async function numberedChart({ dob, tob, location }, chartType, layoutData) {
  const svg = await fetchChartSvg({ dob, tob, location, chartType, style: 'North' })
  const layout = buildChartLayout(layoutData, vargaShortKey(chartType))
  const meta = CHART_TYPES.find((c) => c.key === chartType)
  // Same fallback as the Charts tab: VedAstro's plain chart when the
  // numbered overlay can't be built.
  return { key: chartType, meta, svg: buildNumberedSvg(stripPlanetLayer(svg), layout) || svg }
}

/**
 * Everything the six studio tabs show, gathered in one go for the PDF. Every
 * call is the same memoised VedAstro request the tabs make, so tabs the user
 * already opened cost nothing extra. The planet table is the one hard
 * requirement — every other section degrades to null on its own.
 */
export async function collectReport(birth) {
  const args = { dob: birth.dob, tob: birth.tob, location: birth.location }
  const today = new Date().toISOString().slice(0, 10)

  const [planets, houses] = await Promise.all([getAllPlanetData(args), soft(getAllHouseData(args))])
  const layoutData = houses ? chartLayoutData(planets, houses) : null

  const [panchang, charts, tree, sav, predictions, saturnSign] = await Promise.all([
    soft(getPanchang({ date: birth.dob, time: birth.tob, location: birth.location })),
    Promise.all(REPORT_CHARTS.map((key) => soft(numberedChart(args, key, layoutData)))),
    soft(getDashaTree(args)),
    soft(getSarvashtakavarga(args)),
    soft(getPredictionsCached(args)),
    soft(getSaturnTransitSign(today)),
  ])

  const moon = planets.find((p) => p.name === 'Moon')
  return {
    birth,
    generatedAt: new Date(),
    planets,
    houses,
    avakhada: buildAvakhada({ planets, houses: houses || [], panchang }),
    charts: charts.filter(Boolean),
    dashas: tree ? { tree, running: findRunningPath(tree, new Date()) } : null,
    sav,
    doshas: {
      manglik: computeManglik(planets),
      kalsarpa: computeKalsarpa(planets),
      sadesati: saturnSign && moon ? sadesatiStatus(moon.sign, saturnSign) : null,
    },
    yogas: predictions ? extractYogas(predictions) : null,
    remedies: planets.map((p) => ({ ...p, remedy: remedyFor(p.name) })).filter((p) => p.afflicted && p.remedy),
    lifeReport: predictions ? groupPredictions(predictions) : null,
  }
}
